// @flow

import type { State } from '../../types';
import { getConfiguration } from '../selectors';
import { getSiteName } from '../../wpSettings';
import { getCartPrice } from '../../configuration';

export const purchase = (state: State, ordernumber: string) => {
  const id = ordernumber;
  const product = getConfiguration(state);
  const affiliation = getSiteName(state);
  const revenue = getCartPrice(state);

  return {
    event: 'purchase',
    ecommerce: {
      currencyCode: 'EUR',
      purchase: {
        actionField: {
          id,
          affiliation,
          revenue,
        },
        products: [{
          ...product,
        }],
      },
    },
  };
};

export default null;
